import { createTheme, makeStyles, ThemeProvider } from "@material-ui/core";
import { isNull } from "App/utils/helpers";
import { useDispatchWrapper } from "hooks";
import React from "react";

export default function WrapperThemeProvider({ children }) {
  const theme = useTheme();
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

const useTheme = () => {
  const { state } = useDispatchWrapper();
  const themeList = state.theme_list;
  const theme = createTheme({
    overrides: {
      MuiTabs: {
        root: {
          backgroundColor: isNull(themeList.tab) ? "#FFF" : themeList.tab,
          color: isNull(themeList.tab_color) ? "#296218" : themeList.tab_color,
          // border: `1px solid ${isNull(themeList.tab_active) ? '#296218' : themeList.tab_active}`,
        },
      },
      MuiTab: {
        root: {
          "&:hover": {
            backgroundColor: isNull(themeList.tab_active)
              ? "#296218"
              : themeList.tab_active,
            color: isNull(themeList.tab_active_color)
              ? "#FFF"
              : themeList.tab_active_color,
          },
          "&$selected": {
            backgroundColor: isNull(themeList.tab_active)
              ? "#296218"
              : themeList.tab_active,
            color: isNull(themeList.tab_active_color)
              ? "#FFF"
              : themeList.tab_active_color,
          },
          border: `1px solid ${
            isNull(themeList.tab_active) ? "#296218" : themeList.tab_active
          } !important`,
        },
      },
      MuiTabScrollButton: {
        root: {
          height: "40px",
        },
      },
      MuiPaper: {
        root: {
          backgroundColor: `${
            isNull(themeList.card_background)
              ? "#FAFAFA"
              : themeList.card_background
          }!important`,
        },
      },
      Modal: {
        title: {
          backgroundColor: isNull(themeList.tab_active)
            ? "#296218"
            : themeList.tab_active,
          color: isNull(themeList.tab_active_color)
            ? "#FFF"
            : themeList.tab_active_color,
        },
      },
      MuiTableRow: {
        body: {
          "&$active": {
            backgroundColor: "#00b0f2!important",
          },
        },
      },
      // MuiTableCell:{
      //   body:{
      //     color:'#FFF',
      //   }
      // }
    },
  });

  return theme;
};

export const useStylesWrapperTab = () => {
  const { state } = useDispatchWrapper();
  const themeList = state.theme_list;
  const useStyles = makeStyles(() => ({
    active: {},
    tabMenu_item_menu_wrapper: {},
    tabMenu_item_menu: {},
    tabMenu_item_icon: {},
    tabMenu_item: {
      fontSize: "10px",
      fontWeight: "600",
      margin: "0.5rem 0.2rem 0 0.2rem",
      zIndex: "3",

      "& > $tabMenu_item_menu_wrapper": {
        display: "flex",
        alignItems: "center",
        position: "relative",
        backgroundColor: isNull(themeList.tab) ? "#979797" : themeList.tab,
        borderRadius: "6px",
        "& button": {
          color: isNull(themeList.tab_color) ? "#FFFFFF" : themeList.tab_color,
        },
        "&:hover": {
          "& button": {
            color: isNull(themeList.tab_active_color)
              ? "#FFFFFF"
              : themeList.tab_active_color,
            backgroundColor: isNull(themeList.tab_active)
              ? "#52525B"
              : themeList.tab_active,
          },
          color: isNull(themeList.tab_active_color)
            ? "#FFFFFF"
            : themeList.tab_active_color,
          backgroundColor: isNull(themeList.tab_active)
            ? "#52525B"
            : themeList.tab_active,
        },
        "& > $tabMenu_item_menu": {
          padding: "8px",
          paddingBlock: "10px",
          cursor: "pointer",
          "&:hover": {
            borderRadius: "6px",
          },
        },
        "& > $tabMenu_item_icon": {
          cursor: "pointer",
          padding: "8px",
          paddingBlock: "10px",
          "&:hover": {
            backgroundColor: "red",
          },
        },
      },
      "&$active": {
        "& > $tabMenu_item_menu_wrapper": {
          backgroundColor: isNull(themeList.tab_active)
            ? "#52525B"
            : themeList.tab_active,
          "& button": {
            color: isNull(themeList.tab_active_color)
              ? "#FFFFFF"
              : themeList.tab_active_color,
            backgroundColor: isNull(themeList.tab_active)
              ? "#52525B"
              : themeList.tab_active,
          },
          "& > $tabMenu-item-menu": {
            "& button": {
              backgroundColor: isNull(themeList.tab_active)
                ? "#52525B"
                : themeList.tab_active,
              color: isNull(themeList.tab_active_color)
                ? "#FFFFFF"
                : themeList.tab_active_color + "!important",
            },
          },
          "& > $tabMenu_item_icon": {
            "&:hover": {
              color: isNull(themeList.tab_active_color)
                ? "#FFFFFF"
                : themeList.tab_active_color,
            },
          },
        },
      },
      "&:hover": {
        "& > $tabMenu_item_menu_wrapper": {
          "& > $tabMenu_item_icon": {
            "&:hover": {
              backgroundColor: "red",
            },
          },
        },
      },
    },
  }));
  const classes = useStyles();
  return classes;
};
